// extracted by mini-css-extract-plugin
export default {"main":"menuitem_main__3Z3ZS","menu":"menuitem_menu__-MRt1","title":"menuitem_title__oIo7n","children":"menuitem_children__pm8ZJ"};